export const NAVIGATION_ID_STORAGE_KEY = 'com.grafana.faro.lastNavigationId';

export const NAVIGATION_ENTRY = 'navigation';
export const RESOURCE_ENTRY = 'resource';
